"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.keyboardMode = void 0;
exports.keyboardMode = "data-bui-keyboard";
